import axios from "axios";
import TokenService from "./Token.service";

const jsonInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

const xUrlEncodedInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    "Content-Type": "application/x-www-form-urlencoded;charset=utf-8",
  },
});

const bufferInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  responseType: "blob",
});

[jsonInstance, xUrlEncodedInstance, bufferInstance].forEach(instance => {
  instance.interceptors.request.use(
    (config) => {
      const token = TokenService.getLocalAccessToken();
      if (token) {
        config.headers = config.headers ?? {};
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );
});
// Response interceptor to handle 401 Unauthorized
const handleUnauthorized = () => {
  // Clear any existing tokens
  TokenService.removeUser();
  // Redirect to login page
  window.location.href = '/';
};

// Add response interceptor to handle 401 responses
[jsonInstance, xUrlEncodedInstance, bufferInstance].forEach(instance => {
  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response?.status === 401) {
        handleUnauthorized();
      }
      return Promise.reject(error);
    }
  );
});

export { jsonInstance, xUrlEncodedInstance, bufferInstance };

